import { call, put } from 'redux-saga/effects';
import ERRORS from 'constants/errors';
import STEPS from 'constants/steps';
import {
  setError,
  startLoading,
  stopLoading,
  setStep,
  setFirebaseMfaVerificationProps,
  actionFirebaseMfaSuccess
} from 'reduxConfig/auth.creators';
import { verifyFirebaseNativeMfaCode, initFirebaseNativeMfa } from './firebaseNativeMfa';

import { createLogger } from 'helpers/logger';
const log = createLogger('[auth-saga] firebaseMfa:');

export function* initFirebaseMfa({ credential, resolver, recaptchaContainerId }) {
  yield put(startLoading());
  if (!resolver) {
    log.info(
      'no web mfa resolver, trying to handle init mfa on native firebase... calling initFirebaseNativeMfa'
    );
    yield call(initFirebaseNativeMfa);
    return;
  }
  log.info('recaptchaContainerId', recaptchaContainerId);

  let recaptchaVerifier;
  try {
    if (resolver?.hints[0]?.factorId === 'phone') {
      log.info('phoneNumber', resolver.hints[0].phoneNumber, 'credential', !!credential);
      const phoneInfoOptions = {
        multiFactorHint: resolver.hints[0],
        session: resolver.session
      };

      recaptchaVerifier = yield call(window.FIREBASE.createRecaptchaVerifier, {
        containerId: recaptchaContainerId,
        options: {
          size: 'invisible',
          callback: () => log.info('recaptcha verified')
        }
      });

      log.info('recaptchaVerifier', recaptchaVerifier?.container);

      const verificationId = yield call(window.FIREBASE.verifyPhoneNumber, {
        phoneInfoOptions,
        recaptchaVerifier
      });
      yield put(setFirebaseMfaVerificationProps({ resolver, verificationId }));

      yield put(setStep(STEPS.verifySMSCode));
    } else {
      log.warn('Unsupported second factor');
    }
  } catch (e) {
    console.error(e);
    yield put(setError(ERRORS.authInitFirebaseMfa));
  } finally {
    recaptchaVerifier?.clear(); // recaptcha creates timeouts and it should be cleared up when dismount
    yield put(stopLoading());
  }
}

export function* verifyFirebaseMfaCode({ resolver, verificationId, verificationCode }) {
  yield put(setError(null));
  log.info(
    'verifyFirebaseMfaCode web resolver (if no web resolver, check native) = ',
    resolver?.hints[0]?.factorId,
    verificationId,
    verificationCode
  );
  if (!resolver) {
    yield call(verifyFirebaseNativeMfaCode, { verificationId, verificationCode });
  } else {
    yield put(startLoading());
    try {
      const multiFactorAssertion = yield call(window.FIREBASE.multiFactorAssertion, {
        verificationId,
        verificationCode
      });
      log.info('verifyFirebaseMfaCode.multiFactorAssertion?.factorId', multiFactorAssertion?.factorId);

      const userCredential = yield call(resolver.resolveSignIn.bind(resolver), multiFactorAssertion);
      log.info('verifyFirebaseMfaCode.userCredential', !!userCredential);

      yield put(actionFirebaseMfaSuccess({ userCredential }));
    } catch (e) {
      if (e.code === 'auth/invalid-verification-code') {
        yield put(setError(ERRORS.twoFactor));
      } else {
        log.error('verifyFirebaseMfaCode: ', e);
        yield put(setError(ERRORS.signup));
      }
    } finally {
      yield put(stopLoading());
    }
  }
}
